var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLampada(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6133 63.2222H51.3822M41 1V5.44444M69.2844 12.7156L66.1422 15.8578M81 41H76.5556M5.44444 41H1M15.8578 15.8578L12.7156 12.7156M25.2844 56.7156C22.1772 53.6075 20.0613 49.6479 19.2043 45.3373C18.3474 41.0268 18.7878 36.559 20.4699 32.4987C22.152 28.4385 25.0003 24.9682 28.6546 22.5266C32.3089 20.0851 36.6051 18.7819 41 18.7819C45.3949 18.7819 49.6911 20.0851 53.3454 22.5266C56.9997 24.9682 59.848 28.4385 61.5301 32.4987C63.2122 36.559 63.6526 41.0268 62.7957 45.3373C61.9387 49.6479 59.8228 53.6075 56.7156 56.7156L54.28 59.1467C52.8876 60.5393 51.7831 62.1926 51.0297 64.0121C50.2763 65.8317 49.8886 67.7818 49.8889 69.7511V72.1111C49.8889 74.4686 48.9524 76.7295 47.2854 78.3965C45.6184 80.0635 43.3575 81 41 81C38.6425 81 36.3816 80.0635 34.7146 78.3965C33.0476 76.7295 32.1111 74.4686 32.1111 72.1111V69.7511C32.1111 65.7733 30.5289 61.9556 27.72 59.1467L25.2844 56.7156Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLampada);
export default __webpack_public_path__ + "static/media/icon_lampada.deb2014f6fcbeb6f23f5c8d6e9b6e679.svg";
export { ForwardRef as ReactComponent };